import { JwtHelperService } from '@auth0/angular-jwt';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { Subscription } from 'rxjs';
import { ResponseStructure } from '@iq-central-front-end/share';
import { GlobalService } from '../../_services/global.service';

@Component({
  selector: 'iq-central-front-end-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit, OnDestroy {
  GUID: any;
  GUID2: any;
  sub: Subscription = new Subscription();
  token: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _auth: AuthService,
    private _global: GlobalService,
    private _jwt: JwtHelperService
  ) {}

  ngOnInit(): void {
    this._global.showSpinner();
    this.GUID = this.route.snapshot.paramMap.get('id');
    this.GUID2 = this.route.snapshot.paramMap.get('guid');
    const payload = {
      guid: this.GUID,
      guid2: this.GUID2,
    };

    this.sub.add(
      this._auth.guidLogin(payload).subscribe({
        next: (res: ResponseStructure) => {
          this._global.hideSpinner();
          this.token = res.responseResult['token'];

          localStorage.setItem(
            'userDetails',
            JSON.stringify(this._jwt.decodeToken(this.token))
          );
          localStorage.setItem('token', this.token);
          this.router.navigate(['/']);
        },
        error: (e) => {
          this._global.hideSpinnerWithMessage(e.error, 'error');
        },
      })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
